// extracted by mini-css-extract-plugin
export default {"form":"EmailConfirmationForm_form__wXvIw","content":"EmailConfirmationForm_content__hAivV","inset":"EmailConfirmationForm_inset__RrPyY"};